<template>
  <div>
    <el-badge :value="node.data.unansweredEvaluationsCount" :hidden="node.data.unansweredEvaluationsCount == 0"
      class="item tree-node-title" type="primary">
      {{ node.data.name }}
      <el-popover v-if="node.data.lastTelemetryValue && node.data.lastTelemetryValue.value" placement="top" trigger="hover" style="display:inline-block">
        <div slot="reference" style="width:auto;font-size:12px;border-radius:5px; padding:4px;border:1px solid #eeeeee"
          v-bind:style="{ color: iconStyle.color }">
          <b>{{ node.data.lastTelemetryValue.value.toFixed(2) }}</b>
        </div>
        <div>
          <b>{{ node.data.lastTelemetryValue.telemetry }}</b>
        </div>
      </el-popover>
    </el-badge>

    <el-dropdown slot="dropdown" class="control-group tree-point-options" trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <em class="el-icon-more"></em>
      </span>
      <el-dropdown-menu slot="dropdown" :placement="'top'">
        <el-dropdown-item v-if="checkPermission('updatePoint')" command="edit">{{ $t("tree.edit") }}</el-dropdown-item>
        <el-dropdown-item v-if="checkPermission('deletePoint')" command="delete" divided>{{ $t("tree.delete") }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <EditPoint :title="$t('tree.editpoint')" :visible.sync="showEditPoint" :id="node.data._id" v-on:updated="updated"
      v-on:cancelled="editPointCancelled">
    </EditPoint>
  </div>
</template>
<script>
import EditPoint from "./EditPoint";
import axios from "axios";
import dayjs from 'dayjs';

export default {
  name: "TreePoint",
  props: ["node"],
  events: ["pointDeleted", "pointUpdated"],
  components: { EditPoint },
  data() {
    return {
      showEditPoint: false,

      iconStyle: {
        color: "black",
      },
    };
  },
  created() {
    if (this.node.data.health && this.node.data.health.name) {
      if (this.node.data.health.name == "critical") {
        this.iconStyle.color = "red";
      } else if (this.node.data.health.name == "hazard") {
        this.iconStyle.color = "#f99314";
      } else if (this.node.data.health.name == "attention") {
        this.iconStyle.color = "#f9d214";
      } else if (this.node.data.health.name == "healthy") {
        this.iconStyle.color = "#23d020";
      }
    }
  },
  methods: {
    friendlyDate(d){
      
      //fromnow
      return dayjs().diff(dayjs(d),"minute") + " "+this.$t("common.minute") +" "+ this.$t("common.ago");

    },
    deviceCreated(device) {
      this.node.data.device = device;
      this.showCreateDevice = false;
    },
    clicked(e) {
      this.node.selected(true);
      e.preventDefault();
      e.stopPropagation();
    },
    editPointCancelled() {
      this.showEditPoint = false;
    },
    updated(data) {
      this.$emit("pointUpdated", this.node, data);
      this.showEditPoint = false;
    },
    handleCommand(command) {
      switch (command) {
        case "edit":
          this.showEditPoint = true;
          break;
        case "updateDevice":
          this.showEditDevice = true;
          break;
        case "delete":
          this.$confirm(this.$t("tree.warningtext"), this.$t("tree.warning"), {
            confirmButtonText: this.$t("tree.warningConfirmText"),
            cancelButtonText: this.$t("tree.warningCancelText"),
            type: "warning",
          })
            .then(() =>
              axios.delete(
                `${process.env.VUE_APP_APIURL}/point/${this.node.data._id}`
              )
            )
            .then(() => {
              this.$emit("pointDeleted", this.node);
              this.$message({
                type: "success",
                message: this.$t("tree.DeleteCompleted"),
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("tree.DeleteCanceled"),
              });
            });
          break;
      }
    },
  },
};
</script>